/**
 * 承諾内容
 */
export type ConsentQuestions = {
  consentQuestion1?: string
  consentQuestion2?: string
  consentQuestion3?: string
  consentQuestion4?: string
  consentQuestion5?: string
  consentQuestion6?: string
  consentQuestion7?: string
  consentQuestion8?: string
  consentQuestion9?: string
  consentQuestion10?: string
  consentQuestion11?: string
  consentQuestion12?: string
  consentQuestion13?: string
  consentQuestion14?: string
  consentQuestion15?: string
  consentQuestion16?: string
  consentQuestion17?: string
  consentQuestion18?: string
  consentQuestion19?: string
  consentQuestion20?: string
}

interface QuestionProps {
  id: keyof ConsentQuestions
  contents: string[]
  warn: boolean
}

/**
 * 承諾内容のリスト
 */
const questions: QuestionProps[] = [
  {
    id: 'consentQuestion1',
    contents: ['①申込みにあたり、下記項目を確認のうえ、すべて自己の判断・責任において回答します。'],
    warn: true,
  },
  {
    id: 'consentQuestion2',
    contents: [
      '②勧誘を受けるに先立って、㋐勧誘者の氏名（または名称）、㋑貴社（統括者）の名称、㋒特定負担を伴う取引について勧誘する目的である旨及び㋓勧誘に係る商品及び役務の種類のすべてについて明らかにしてもらいました。',
    ],
    warn: true,
  },
  {
    id: 'consentQuestion3',
    contents: [
      '③入会の申込みにあたり、「AUBEクエストコネクタープラン制度　概要書面」の内容を熟読し、理解し、納得の上自己責任でAUBEクエストコネクタープラン制度の登録を申し込みます。',
    ],
    warn: true,
  },
  {
    id: 'consentQuestion4',
    contents: ['④入会に当たっての不明点がある場合は、そのままにせず必ずクーリングオフ期間内に貴社まで問い合わせます。'],
    warn: true,
  },
  {
    id: 'consentQuestion5',
    contents: ['⑤AUBEクエストコネクタープラン概要書面を確かに受領しました。'],
    warn: true,
  },
  {
    id: 'consentQuestion6',
    contents: ['⑥このプランの申込みを行う目的は専らAUBEクエストを普及させることにあり、投資による収益の獲得等を目的としたものではないことを受諾します。'],
    warn: true,
  },
  {
    id: 'consentQuestion7',
    contents: ['⑦このプランの申込み及びそれと同一または密接した時期に行う他の申込みとをすべて合算した申込数は、自身にとって必要であると自らが判断したものであることを承諾します。'],
    warn: true,
  },
  {
    id: 'consentQuestion8',
    contents: [
      '⑧商品内容、収益性、将来性等々に不満があり、自分自身でよく考え気持ちが変わらなかった場合は、たとえ引き止められても必ず20日間のクーリングオフ期間内に直接貴社まで契約の解除を書面または電磁的記録（電子メール等）にて申し出ます。',
    ],
    warn: true,
  },
  {
    id: 'consentQuestion9',
    contents: ['⑨特定商取引に関する法律の規定に従い、20日間のクーリングオフ期間が経過した後や本サービス内の課金は、返品、返金できないことを了承します。'],
    warn: true,
  },
  {
    id: 'consentQuestion10',
    contents: ['⑩AUBEクエストコネクタープラン制度登録は、特定商取引に関する法律に規定する連鎖販売取引に該当することを了承します。'],
    warn: false,
  },
  {
    id: 'consentQuestion11',
    contents: ['⑪AUBEクエストコネクタープラン制度規約には全面的に従い、規約の内容はすべて了承します。'],
    warn: false,
  },
  {
    id: 'consentQuestion12',
    contents: [
      '⑫AUBEクエストコネクタープラン制度　概要書面」の「第2章 2.AUBEクエストコネクターの報酬（特定利益）について」の内容を承諾しました。',
      '特定利益は、コネクターおよびユーザーゲーム内課金の獲得実績に応じて、「第2章 2. AUBEクエストコネクターの報酬（特定利益）について」に定めるところに従って発生することを了承します。',
    ],
    warn: false,
  },
  {
    id: 'consentQuestion13',
    contents: ['⑬特定商取引に関する法律等各種法令やAUBEクエストコネクタープラン制度の規約に違反した場合、コネクターとしての資格を失う場合があることを了承します。'],
    warn: false,
  },
  {
    id: 'consentQuestion14',
    contents: ['⑭必ず儲かるとは限らず、収益を得られない場合もあることを了承します。'],
    warn: true,
  },
  {
    id: 'consentQuestion15',
    contents: ['⑮商品内容、商品価格、会員規約、報酬体系等が、将来予告なく変更される場合があることを了承します。'],
    warn: false,
  },
  {
    id: 'consentQuestion16',
    contents: ['⑯商品ラインナップが将来変更される可能性があることを了承します。'],
    warn: false,
  },
  {
    id: 'consentQuestion17',
    contents: ['⑰各種法令や会員規約に反する活動を行ったことで解約問題が発生した場合、自らの責任と費用で速やかに解決し、貴社に損害を与えないことを確約します。'],
    warn: false,
  },
  {
    id: 'consentQuestion18',
    contents: [
      '⑱所定の期日までにAUBEクエストコネクタープラン申込手続きが完了しなかった場合、申込月にさかのぼりAUBEクエストコネクターの資格が停止され、報酬が支払われないことを了承します。',
    ],
    warn: false,
  },
  {
    id: 'consentQuestion19',
    contents: ['⑲報酬取得権利確定課金が確認できなかった場合、実績があったとしても報酬は支払われないことを了承します。'],
    warn: false,
  },
  {
    id: 'consentQuestion20',
    contents: [
      '⑳取扱いにおいて、AUBEクエストコネクタープラン制度申込書記載の申込人の情報を一部当社の判断で上位者に開示します。',
      'コネクターは、付帯するサービス提供のための必要な個人情報を株式会社イー・コミュニケーションズから個人情報の預託に関する契約を締結したサービス提供会社に預託することに同意します。',
    ],
    warn: false,
  },
]

export default questions
